export enum VisibilityTypes {
    NOT_VISIBLE = 1,
    VISIBLE_TO_PUBLIC = 2,
    VISIBLE_TO_ADMINISTRATION = 3,
    ALWAYS_VISIBLE = 4,
}